import React from "react";
import { object, array, string, any } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import TheQuintLogo from "../../atoms/icons/the-quint-logo";
import HindiQuintLogo from "../../atoms/icons/hindi-quint-logo";
import MenuItem from "../../atoms/menu-item";
import LinkView from "../../atoms/link-view";
import FitColorLogo from "../../atoms/icons/fit-color-logo";
import SocialIcons from "../../molecules/social-icons";
import StickyBanner from "../../molecules/sticky-banner";

import translate from "../../translate";

import "./footer.m.css";

const Footer = ({ secondaryMenuItems, trendingTopics, publisherAttributes, publisherName, currentHostUrl }) => {
  const getLogoView = () => {
    if (publisherName === "quint-hindi") {
      return <HindiQuintLogo />;
    } else if (publisherName === "fit") {
      return <FitColorLogo width={107} height={60} />;
    } else {
      return <TheQuintLogo width={95} height={60} />;
    }
  };

  const getQuintLinkView = () => (
    <LinkView className="menu-item-link" link="https://thequint.com/">
      Quint
    </LinkView>
  );

  const getFitLinkView = () => (
    <LinkView
      className="menu-item-link"
      link={(publisherAttributes && publisherAttributes.fit_url) || "https://fit.thequint.com/"}
    >
      FIT
    </LinkView>
  );

  const getQuintHindiLinkView = () => (
    <LinkView className="menu-item-link" link="https://hindi.thequint.com/">
      Quint Hindi
    </LinkView>
  );

  const getWebsiteLinks = () => {
    if (publisherName === "quint-hindi") {
      return (
        <React.Fragment>
          {getQuintLinkView()}
          {getFitLinkView()}
        </React.Fragment>
      );
    }

    if (publisherName === "fit") {
      return (
        <React.Fragment>
          {getQuintHindiLinkView()}
          {getQuintLinkView()}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {getQuintHindiLinkView()}
        {getFitLinkView()}
      </React.Fragment>
    );
  };

  return (
    <>
      <div styleName="wrapper">
        <div className="container">
          <div styleName="content">
            {/* Sections */}
            <div>
              <div styleName="name">SECTIONS</div>
              <ul styleName="menu-list">
                {secondaryMenuItems.map((item, index) => (
                  <li key={index} styleName="menu-item" className={`footer-sections-${index + 1}`}>
                    <MenuItem item={item} currentHostUrl={currentHostUrl} />
                  </li>
                ))}
              </ul>
            </div>

            {/* Trending Topics */}
            <div styleName="trending">
              <div styleName="name">TRENDING TOPICS</div>
              <ul styleName="menu-list">
                {trendingTopics.map((item, index) => (
                  <li key={index} styleName="menu-item" className={`footer-trending-topic-${index + 1}`}>
                    <MenuItem item={item} currentHostUrl={currentHostUrl} />
                  </li>
                ))}
              </ul>
            </div>

            {/* Others */}
            <div styleName="others">
              <Link href="/" styleName="main-logo">
                {getLogoView()}
              </Link>

              {/* Soical Icons */}
              <div styleName="follow-us">
                <div styleName="follow-us-name">{translate(publisherName, "follow_us_on")}</div>
                <SocialIcons />
              </div>

              {/* Sections and Other Links */}
              <div styleName="web-links">
                <div>
                  <LinkView className="menu-item-link" link="https://www.bloombergquint.com/">
                    Bloomberg Quint
                  </LinkView>

                  {getWebsiteLinks()}
                </div>

                <div>
                  <LinkView className="menu-item-link" link="/about-us" openInNewTab={false}>
                    {translate(publisherName, "about_us")}
                  </LinkView>

                  <LinkView className="menu-item-link" link="/contact-us" openInNewTab={false}>
                    {translate(publisherName, "contact_us")}
                  </LinkView>

                  <LinkView className="menu-item-link" link="/privacy-policy" openInNewTab={false}>
                    {translate(publisherName, "privacy_policy")}
                  </LinkView>

                  <LinkView className="menu-item-link" link="/terms-and-conditions" openInNewTab={false}>
                    {translate(publisherName, "t_and_c")}
                  </LinkView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StickyBanner publisherName={publisherName} />
    </>
  );
};

Footer.propTypes = {
  secondaryMenuItems: array,
  trendingTopics: any,
  publisherAttributes: object,
  publisherName: string,
  currentHostUrl: string,
};

const mapStateToProps = (state) => ({
  secondaryMenuItems: get(state, ["qt", "data", "navigationMenu", "secondaryMenuItems"], []),
  trendingTopics: get(state, ["qt", "data", "navigationMenu", "trendingTopics"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  currentHostUrl: get(state, ["qt", "currentHostUrl"], ""),
});

export default connect(mapStateToProps, null)(Footer);
